import { Col } from "antd";
import React from "react";
import building from "../../images/building.jpg";

const ImageComponent = () => {
  return (
    <Col
      xs={{ span: 0 }}
      xl={{ span: 12 }}
      style={{
        minHeight: "100vh",
        background: `linear-gradient(0deg,rgba(21,101,216,0.9),rgba(21,101,216,0.9)),url(${building}) no-repeat center center/cover`,
      }}
    ></Col>
  );
};

export default ImageComponent;
